import { View, Text, ScrollView } from "react-native";
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Image, Button, Icon } from "@rneui/base";
import { styles } from "../styles/mainStyle";
import Collection from "../components/Collection";
import Toast from "react-native-toast-message";
import {
  doc,
  updateDoc,
  getDocs,
  collection,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import { TouchableOpacity } from "react-native";

const OldHome = ({ navigation, route }) => {
  const [products, setProducts] = useState([]);
  const [drnProd, setDrnProd] = useState([]);
  const [finalProducts, setFinalProducts] = useState([]);
  const [productos, setProductos] = useState([]);
  const [cliente, setCliente] = useState();
  const [clienteDrn, setClienteDrn] = useState();

  useEffect(() => {
    const clean = route.params.replace("@mail.com", "");
    getDoc(doc(db, "clientesero", clean))
      .then((docSnap) => {
        const data = docSnap.data();
        console.log(docSnap.data());
        setCliente(data);
      })
      .then(() => {
        console.log(cliente);
      });
  }, []);

  useEffect(() => {
    console.log("im happening");
    const clean = route.params.replace("@mail.com", "");
    console.log(clean);
    getDoc(doc(db, "clientesdrn", clean))
      .then((docSnap) => {
        const data = docSnap.data();
        console.log(docSnap.data());
        setClienteDrn(data);
      })
      .then(() => {
        console.log(clienteDrn);
      });
  }, []);

  // erotarifa1
  // erotarifa20
  // erotarifa22

  // drntarifa1
  // drntarifa20
  // drntarifa21
  // drntarifa22
  // drntarifa23

  const listaEro = "erotarifa1";
  const listaDrn = "drntarifa22";

  const showToast = () => {
    console.log("im suposed to be happening");
    Toast.show({
      type: "success",
      text1: "Todavia",
      text2: "ir al perfil",
    });
  };

  const check = () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
    };

    fetch(
      "http://sa08.ddns.net:7780/AppAndroid/servlet/ServletAndroid?empresa=drn&usuario=consultaweb&clave=web3007&dato=enviodocumento&documento=<documento><detallePedido><detallepedido><cantidad>1</cantidad><codigo>100/L</codigo><denominacion>MUSCULOSA CUELLO BOTE DAMA L </denominacion><incluye__iva>N</incluye__iva><iva>21</iva><modprecio>S</modprecio><porbonif>0</porbonif><precio>171.59</precio><precio__con__iva>207.624</precio__con__iva><precio__id>1</precio__id></detallepedido><detallepedido><cantidad>2</cantidad><codigo>1005/S</codigo><denominacion>SALSA DE TOMATES S 1000 KI</denominacion><incluye__iva>N</incluye__iva><iva>21</iva><modprecio>S</modprecio><porbonif>0</porbonif><precio>1.19</precio><precio__con__iva>1.44</precio__con__iva><precio__id>1</precio__id></detallepedido></detallePedido><sObservaciones></sObservaciones><sPersona__id>1000027</sPersona__id><sPersonaliza></sPersonaliza><sTipo>Nota de Pedido</sTipo><sTransporte__id>0</sTransporte__id></documento>",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  const testda = () => {
    console.log("chec");
    getDocs(collection(db, listaEro)).then((docSnap) => {
      docSnap.forEach((doc) => {
        const { codigo, nombre, producto } = doc.data();
        products.push(
          doc.data({
            codigo,
            nombre,
            producto,
          })
        );
      });
      setProducts(products);
      const gonzalo = products;
      // console.log("the zonas");
      // console.log(products);

      // const gonzalo = [].concat(
      //   products[0].test.vdato.productosweb,
      //   products[1].test.vdato.productosweb,
      //   products[2].test.vdato.productosweb,
      //   products[3].test.vdato.productosweb,
      //   products[4].test.vdato.productosweb,
      //   products[5].test.vdato.productosweb,
      //   products[6].test.vdato.productosweb,
      //   products[7].test.vdato.productosweb,
      //   products[8].test.vdato.productosweb,
      //   products[9].test.vdato.productosweb
      // );

      // // Array.prototype.push.apply(
      // //   gonzalo,
      // //   products[1].test.vdato.productosweb,
      // //   products[2].test.vdato.productosweb,
      // //   products[3].test.vdato.productosweb,
      // //   products[4].test.vdato.productosweb,
      // //   products[5].test.vdato.productosweb,
      // //   products[6].test.vdato.productosweb,
      // //   products[7].test.vdato.productosweb,
      // //   products[8].test.vdato.productosweb,
      // //   products[9].test.vdato.productosweb
      // // );

      // console.log(gonzalo);
      setProducts(gonzalo);
      console.log(gonzalo);
      drnGet();
    });
  };

  const drnGet = () => {
    console.log("drnget happening");
    getDocs(collection(db, listaDrn)).then((docSnap) => {
      docSnap.forEach((doc) => {
        const { codigo, nombre, producto } = doc.data();
        drnProd.push(
          doc.data({
            codigo,
            nombre,
            producto,
          })
        );
      });
      // setDrnProd(drnProd[0].test.vdato.productosweb);
      setDrnProd(drnProd);
      console.log("the zonas");
      console.log(drnProd);
      prev();
    });
  };

  const prev = () => {
    console.log("from use effect");
    console.log(products);
    if (products.length > 0) {
      const filteredHomes = products.filter(
        (x) => x.TIPO != "2 - K-C / R-C / T"
      );
      setFinalProducts(filteredHomes);
      finish();
    }
  };

  const finish = () => {
    console.log(" 12 im here");

    console.log("12 im  ALSO here");
    const gonzalo = [].concat(drnProd, products);
    console.log("this is gon");
    console.log(gonzalo);
    setProductos(gonzalo);
  };

  // useEffect(() => {
  //   console.log("from use effect");
  //   console.log(products);
  //   if (products.length > 0) {
  //     const filteredHomes = products.filter(
  //       (x) => x.TIPO != "2 - K-C / R-C / T"
  //     );
  //     setFinalProducts(filteredHomes);
  //   }
  // }, [drnProd]);

  // useEffect(() => {
  //   console.log(" 12 im here");
  //   if (drnProd.length > 0 && finalProducts.length > 0) {
  //     console.log("12 im  ALSO here");
  //     const gonzalo = [].concat(drnProd, finalProducts);
  //     console.log("this is gon");
  //     console.log(gonzalo);
  //     setProductos(gonzalo);
  //   }
  // }, [finalProducts]);

  const produ = [
    {
      subfamilia: "ARANDELAS VARIAS",
      stock: "0",
      sku: "A-00008-0",
      tipo: "9 - OTROS",
      familia: "A-",
      precio: "20",
      nombre: "ARANDELA SEGURO SACHS 98",
    },
    {
      stock: "181",
      subfamilia: "A-",
      precio: "7.6",
      sku: "A-00010-0",
      familia: "A-",
      nombre: "ARAND. SEGURO EMBRAGUE PUMA 4TA",
      tipo: "9 - OTROS",
    },
    {
      familia: "A-",
      nombre: "ARANDELA COMPENSACION",
      sku: "A-00013-0",
      stock: "0",
      subfamilia: "A-",
      tipo: "9 - OTROS",
      precio: "1.344",
    },
    {
      stock: "0",
      precio: "5.912",
      familia: "A-",
      tipo: "9 - OTROS",
      nombre: "ARANDELA CUBRE RETEN SACHS",
      subfamilia: "A-",
      sku: "A-00014-0",
    },
  ];
  return (
    <ScrollView style={{ backgroundColor: "#F4F6FD" }}>
      <Header title={"Tienda"} />
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          marginVertical: 10,
        }}
      >
        <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          onPress={() => navigation.navigate("Store", productos)}
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
        >
          Ver Catálogo
          <Image
            source={require("../assets/cart-shopping-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
        <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          onPress={() => testda()}
        >
          Ir a mi Perfíl
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
        {/* <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          onPress={() => navigation.navigate("nuStore", products)}
        >
          Check
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button> */}
      </View>
      <TouchableOpacity
        onPress={() => {
          console.log(products);
          console.log(drnProd);
          console.log(productos);
        }}
      >
        <Image
          source={require("../assets/eroban.jpg")}
          style={{
            width: "100vw",
            height: "100vw",
            resizeMode: "contain",
          }}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          console.log(cliente);
          console.log(route.params);
          console.log(clienteDrn);
        }}
      >
        <Text style={styles.sectionTitle}>Novedades</Text>
      </TouchableOpacity>
      <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        <Collection products={produ} type={false} />
      </View>
      {/* <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          onPress={check}
        >
          Check
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button> */}
    </ScrollView>
  );
};

export default OldHome;
